import React from "react";
import { OrdersItems } from "./OrdersItems";
import {OrdersWrapper} from '../Layout/OrdersWrapper';

 const OrdersList = ({ orders, phone_screen }) => {
  return (
    <OrdersWrapper>
        <h1>My orders</h1>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-6  col-6'>
            <div>
                <h6>Product</h6>
              </div>
          </div>
          <div className='col-lg-6 col-6 d-flex justify-content-around'>
            <div>
              <h6>Price</h6>
            </div>
            <div>
              <h6>Status</h6>
            </div>
          </div>
          <div className='borderAll borderGrey mb-1'></div>
           { orders.map((item) => {
             return <OrdersItems key={item.id} phone_screen={phone_screen} item={item} />
           }) }
        </div>
      </div>
    </OrdersWrapper>
  )
};



export { OrdersList as default };
